const development_tenant = {
    notification: '開発モードです',
};
export default Object.freeze(development_tenant);
